import React from 'react';

import PropTypes from 'prop-types';

import { cn } from '@/lib/utils';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';

const FIELD_STYLES = {
  default: '',
  ghost:
    'border-none px-0 text-lg md:text-lg font-semibold shadow-none focus-visible:ring-0',
};

const InputField = ({
  control,
  name,
  label = '',
  labelEnd = null,
  placeholder = '',
  type = 'text',
  variant = 'default',
}) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem>
        {(label || labelEnd) && (
          <div
            className={cn('flex items-center', label ? 'justify-between' : 'justify-end')}
          >
            {label && <FormLabel>{label}</FormLabel>}
            {labelEnd}
          </div>
        )}

        <FormControl>
          <Input
            {...field}
            className={FIELD_STYLES[variant]}
            placeholder={placeholder}
            type={type}
          />
        </FormControl>

        <FormMessage />
      </FormItem>
    )}
  />
);

InputField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelEnd: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'ghost']),
};

export default InputField;
